module.exports = "<div>\n  <pdf-viewer [src]=\"pdfSrc\"></pdf-viewer>\n</div>\n\n<!--<ion-fab vertical=\"top\" horizontal=\"start\" slot=\"fixed\" (click)=\"close()\">-->\n<!--  <ion-fab-button>-->\n<!--    <ion-icon name=\"close\"></ion-icon>-->\n<!--  </ion-fab-button>-->\n<!--</ion-fab>-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/detalhe-pdf/detalhe-pdf.component.html
// module id = ./src/app/components/detalhe-pdf/detalhe-pdf.component.html
// module chunks = main